import { ApiHandler, createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { DivisionModel, getDivisionById } from "@tCentro/Services/CENAdminDivisionService";

export interface GetDivisionByIdParameter extends HasOnSuccess<DivisionModel>, HasOnError<string> {
    id: string;
}
 
type HandlerType = ApiHandler<GetDivisionByIdParameter, { apiResult: DivisionModel }>;
 
export const GetDivisionById: HandlerType = async props => {
    try {
           const result = await getDivisionById(props.parameter.id);
           if (props.parameter.onSuccess) {
               props.parameter.onSuccess(result);
           }
       } catch (error: any) {
           if (props.parameter.onError) {
               props.parameter.onError(error?.message ?? "Failed to load Division");
           }
       }
};
 
export const chain = [GetDivisionById];
const getDivisionByIdHandler = createHandlerChainRunner(chain, "getDivisionByIdHandler");
export default getDivisionByIdHandler;
